export default function reducer(state={
    city:null
},action) {
    let { type, payload } = action;
    switch (type){
        case 'CITY_CHANGE':
            state = {...state, ...payload};
            break;
        default:
            break
    }
    return state
}



// WEBPACK FOOTER //
// ./src/reducers/citySelectReducer.js